module.exports = __webpack_public_path__ + "static/media/tumb3.3d357a52.png";